import DocumentsPage from './pages/DocumentsPage'

export const DocumentsRoutes = [
  {
    path: '/documentos',
    name: 'Documents',
    component: DocumentsPage,
    meta: {
      requiresAuth: true
    }
  }
]
